import { ElementsArray } from 'polotno/model/group-model';
import { StoreType } from 'polotno/model/store';

export function bringElementsToFront(store: StoreType, elements: ElementsArray) {
    store.activePage.moveElementsTop(elements.map(element => element.id));
}
